<cm-multi-select
    [options]="options"
    [disabled]="disabled"
    [valueType]="MULTI_SELECT_VALUE_TYPE.Object"
    [params]="params"
    [class.is-invalid]="showErrors"
    [ngModel]="selectedOptions"
    (ngModelChange)="onMultiSelectValueChange($event)"
    [showValues]="true"
>
</cm-multi-select>
